/**
 * Poll for `window.ethereum` (slow extension inject / mobile in-app timing).
 * Aligns with Charge & Strike `useWalletAuth` `waitForInjectedProvider` (~1.5s).
 */
export async function waitForInjectedProvider(timeoutMs = 1500): Promise<boolean> {
  if (typeof window === 'undefined') return false
  const deadline = Date.now() + timeoutMs
  while (Date.now() < deadline) {
    if (window.ethereum) return true
    await new Promise((r) => setTimeout(r, 100))
  }
  return Boolean(window.ethereum)
}

export function isLikelyMissingInjectedProviderError(error: unknown): boolean {
  const msg = String(
    error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  ).toLowerCase()
  if (!msg) return false
  return (
    msg.includes('provider') ||
    msg.includes('injected') ||
    msg.includes('no ethereum') ||
    (msg.includes('ethereum') && msg.includes('not found')) ||
    (msg.includes('wallet') && msg.includes('not found'))
  )
}
